export const GOOGLE_AUTOCOMPLETE_RESULTS_LANGUAGE = 'en';
